/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Button, Icon } from 'antd';
import { withRouter } from 'react-router-dom';
import './FlowNav.scss';

function FlowNav({
  prev = null,
  next = null,
  prevText = 'Previous',
  nextText = 'Next Step',
  disableNext = false,
  placement = 'bottom',
  center = null,
  history,
}) {
  const onPrev = () => {
    if (typeof prev === 'string') history.push(prev);
    else if (typeof prev === 'function') prev();
    window.scrollTo(0, 0);
  };

  const onNext = () => {
    if (typeof next === 'string') history.push(next);
    else if (typeof next === 'function') next();
    window.scrollTo(0, 0);
  };

  if (!prev && !next) return null;

  const rootClass = classNames(
    'flow-nav',
    placement === 'top' && 'flow-nav--top',
    placement === 'bottom' && 'flow-nav--bottom'
  );

  const inner = center ? (
    <>
      <div className="flow-nav__side flow-nav__side--left">
        {prev ? (
          <Button type="default" onClick={onPrev} className="flow-nav__prev">
            <Icon type="left" />
            {prevText}
          </Button>
        ) : null}
      </div>
      <div className="flow-nav__center">{center}</div>
      <div className="flow-nav__side flow-nav__side--right">
        {next ? (
          <Button type="primary" onClick={onNext} className="flow-nav__next" disabled={disableNext}>
            {nextText}
            <Icon type="right" />
          </Button>
        ) : null}
      </div>
    </>
  ) : (
    <>
      {prev ? (
        <Button type="default" onClick={onPrev} className="flow-nav__prev">
          <Icon type="left" />
          {prevText}
        </Button>
      ) : null}
      {next ? (
        <Button type="primary" onClick={onNext} className="flow-nav__next" disabled={disableNext}>
          {nextText}
          <Icon type="right" />
        </Button>
      ) : null}
    </>
  );

  if (placement === 'top') {
    return (
      <nav className={rootClass} aria-label="Plan setup steps">
        {inner}
      </nav>
    );
  }

  return (
    <footer className={rootClass} aria-label="Plan setup steps">
      {inner}
    </footer>
  );
}

FlowNav.propTypes = {
  history: PropTypes.shape({ push: PropTypes.func.isRequired }).isRequired,
  prevText: PropTypes.string,
  nextText: PropTypes.string,
  prev: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  next: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  disableNext: PropTypes.bool,
  placement: PropTypes.oneOf(['top', 'bottom']),
  center: PropTypes.node,
};

export default withRouter(FlowNav);
